import { useState, useCallback } from "react";

export const usePagination = (initialPageSize = 10) => {
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: initialPageSize,
    total: 0,
  });

  const handlePageChange = useCallback((newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  }, []);

  const handlePageSizeChange = useCallback((newPageSize) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newPageSize,
      page: 0, // Reset to first page when changing page size
    }));
  }, []);

  const resetPage = useCallback(() => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
    }));
  }, []);

  const updateTotal = useCallback((total) => {
    setPagination((prev) => ({
      ...prev,
      total: total || 0,
    }));
  }, []);

  const resetPagination = useCallback(() => {
    setPagination({
      page: 0,
      pageSize: initialPageSize,
      total: 0,
    });
  }, [initialPageSize]);

  return {
    pagination,
    handlePageChange,
    handlePageSizeChange,
    resetPage,
    updateTotal,
    resetPagination,
    setPagination,
  };
};